// Pages/Workshops.jsx
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import blacksmithAd from './../assets/blacksmithad3.png'
import knitting from './../assets/knitting.png'
import retreat from './../assets/retreat.png'

function Workshops() {
    return (
        <div>
            {/* Banner */}
            <div className="text-white text-center py-5 mb-5" style={{ backgroundColor: '#d9c2b0' }}>
                <h1 className="display-4">Upcoming Workshops</h1>
            </div>
            <div className='d-flex p-4 justify-content-center text-gray'>
                <div className="loader-container">
                    <div className="pulse-loader"></div>
                    <p>Exciting Things Coming Soon...</p>
                </div>
                {/* <Container className="py-5">
// future event content goes here
                </Container> */}



            </div>
            <div className="text-white text-center py-5 mb-5" style={{ backgroundColor: '#d9c2b0' }}>

                <h1 className="display-4">Previous Workshops</h1>
            </div>

            <Container>
                <Row>
                    <Col md={4}>
                        <img
                            src={retreat}
                            alt="Mindful Macramé Retreat"
                            className="img-fluid rounded shadow workshop-img"
                        />
                    </Col>
                    <Col md={8}>
                        <h2>Mindful Macramé Retreat — Making with the Land</h2>
                        <h4>May 9th, 12-6pm</h4>
                        <p >Step away from the rush of everyday life and spend a restorative day immersed in slow making, nature, and mindful presence.

                            This intimate day retreat takes place on beautiful off-grid land near Tunbridge Wells, where we’ll gather to create natural macramé wall hangings using materials sourced from the land itself. Through gentle, repetitive knotting and guided mindfulness, this day is designed to calm the nervous system and reconnect you with your hands.

                            You’ll be guided step by step through simple macramé knots, learning how to work slowly and intuitively, with plenty of time to settle into the rhythm of making. No prior experience is needed — this retreat is intentionally beginner-friendly.

                            Alongside making, the day will include moments of meditation, reflection, and rest, as well as a nourishing lunch prepared with locally sourced ingredients.
                        </p>
                        <Button disabled href="https://www.eventbrite.co.uk/e/mindful-macrame-retreat-making-with-the-land-tickets-1983465362292?aff=oddtdtcreator">
                            Eventbrite
                        </Button>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col md={4}>
                        <img
                            src={knitting}
                            alt="Intro to knitting"
                            className="img-fluid rounded shadow workshop-img"
                        />
                    </Col>
                    <Col md={8}>
                        <h2>Intro to Knitting</h2>
                        <h4>April 4th, 2-6pm</h4>
                        <p >
                            Join our cozy knitting workshop! Learn the basics of knitting, from casting on to creating simple projects like scarves and hats. Perfect for beginners looking to unwind and create something beautiful.
                        </p>
                        <Button disabled href="https://www.eventbrite.co.uk/e/beginner-knitting-a-cosy-small-group-workshop-tickets-1983385892596?aff=oddtdtcreator">
                            Eventbrite
                        </Button>
                    </Col>
                </Row>

                {/* Intro to Blacksmithing Section */}
                <Row className="mb-5">
                    <Col md={4}>
                        {/* Replace src with your flyer image */}
                        <img
                            src={blacksmithAd}
                            alt="Intro to Blacksmithing"
                            className="img-fluid rounded shadow"
                        />
                    </Col>
                    <Col md={8}>
                        <h2>Intro to Blacksmithing</h2>
                        <p>
                            Join our hands-on blacksmithing workshop! Learn the fundamentals of working with metal,
                            shaping, hammering, and finishing your own small projects. Suitable for beginners.
                        </p>

                        {/* Payment button */}
                        <Button
                            href="mailto:hello@madebyrosita.com?subject=Book Blacksmithing Session"
                            variant="secondary"
                            disabled={true}
                        >
                            Book & Pay
                        </Button>
                    </Col>
                </Row>

                {/* Add more workshops here */}
            </Container>
        </div >
    );
}

export default Workshops;
